import * as Long from "long";
import { of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectFinishedQuestRewards, selectFinishedQuestXp, } from "../../../balancingSelectors/selectBalancingQuests";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TypeActionQuestInfo } from "../../info/quest/actionQuestInfo";
import { actionAddPelletsInScreenCenterAnimation } from "../actionPelletAnimations";
export var epicQuestFinishAnimation = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionQuestInfo.Finish && action.showRewardPellets === true;
    }), switchMap(function (action) {
        var questId = action.questFinish.questId;
        var rewards = selectFinishedQuestRewards(questId);
        var rewardXp = selectFinishedQuestXp(questId);
        var rewardPellets = rewards.map(function (resource) { return getResourceIconInfo(resource); });
        if (rewardXp && rewardXp.notEquals(Long.ZERO)) {
            rewardPellets.push({
                amount: rewardXp,
                icon: IdIcon.XpIcn,
            });
        }
        return of(actionAddPelletsInScreenCenterAnimation(questId, rewardPellets));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/epics/epicQuestFinishAnimation.ts
// module id = 1768
// module chunks = 3